/* eslint-disable no-control-regex -- HTML living standard email pattern (quoted-string / IPv6 literal) */
export const EMAIL_REGEX =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
/* eslint-enable no-control-regex */

export const LINKEDIN_URL_REGEX = /^https?:\/\/(.*\.)?linkedin\.com\/.*$/;

export const DOMAIN_EXTRACTOR_REGEX = /^(?:https?:\/\/)?(?:www\.)?([^/?#]+)/i;

export const HTML_BLOCK_ELEMENT_REGEX =
  /<(p|div|br|ul|ol|li|h[1-6]|blockquote|pre|table|tr|td|th)[\s/>]/i;

export const URL_REGEX =
  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=%-]*)?$/;
